import GameConfig from "../config";

export default class DbClient {
    static init({url}){
        this.baseUrl = url;
    }

    static async getHighscore(){
        try {
            const response = await fetch(`${this.baseUrl}`);
            return await response.json();
        } catch(e){
            console.error("Couldn't fetch highscore");
            return [];
        }
    }

    static async addHighscore({score, name, nameHash}){
        try {
            const response = await fetch(`${this.baseUrl}`,  {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({score, name, s: GameConfig.HIGHSCORE.S, nameHash})
            });
            return await response.json();
        } catch(e){
            console.error("Couldn't send highscore");
            return null;
        }
    }
}